import { View } from 'react-native';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { NavigationContainer, DefaultTheme } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { navigationRef } from '../services/NavigationService';
import { Theme } from '../enum/Theme';
import { EnumRoutesAppWeb } from '../enum/EnumRoutesAppWeb';
import AppHeader from '../comps/AppHeader';
import AppFooter from '../comps/AppFooter';
import Auth from './Auth';
import Dash from './Dash';
import { createDrawerNavigator } from '@react-navigation/drawer';
import Menu from './Menu';
import { useEffect } from 'react';
import UserDetail from './UserDetail';
import Users from './Users';
import Blog from './Blog';
import Desenvolver from './Desenvolver';
import BlogCategoryList from './BlogCategoryList';
import BlogCategoryForm from './BlogCategoryForm';
import PostForm from './PostForm';
import Activities from './Activities';
import ActivityForm from './ActivityForm';
import Extras from './Extras';
import ExtraForm from './ExtraForm';
import DesenvolvimentoForm from './DesenvolvimentoForm';
import ShoppingForm from './ShoppingForm';
import Shopping from './Shopping';
import BannerList from './BannerList';
import BannerForm from './BannerForm';
import PushList from './PushList';
import PushForm from './PushForm';

const DashScreens = createNativeStackNavigator();
const Drawer = createDrawerNavigator();

const themeTab = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    background: Theme.background,
  },
};

const screenOptions = {
  headerTintColor: Theme.secondary,
  headerBackButtonDisplayMode: 'minimal' as const,
  headerBackTitle: '',
  headerBackTitleVisible: false,
  headerStyle: { backgroundColor: Theme.foreground },
  headerTitleStyle: { color: Theme.secondary },
};

const Nav = () => (
  <DashScreens.Navigator>
    <DashScreens.Group screenOptions={{ headerShown: false }}>
      <DashScreens.Screen name={EnumRoutesAppWeb.auth} component={Auth} />
      <DashScreens.Screen name={EnumRoutesAppWeb.dashboard} component={Dash} />
      <DashScreens.Screen name={EnumRoutesAppWeb.users} component={Users} />
      <DashScreens.Screen
        name={EnumRoutesAppWeb.shopping}
        component={Shopping}
      />
      <DashScreens.Screen name={EnumRoutesAppWeb.blog} component={Blog} />
      <DashScreens.Screen
        name={EnumRoutesAppWeb.blogCategories}
        component={BlogCategoryList}
      />
      <DashScreens.Screen
        name={EnumRoutesAppWeb.desenvolver}
        component={Desenvolver}
      />
      <DashScreens.Screen
        name={EnumRoutesAppWeb.activities}
        component={Activities}
      />
      <DashScreens.Screen name={EnumRoutesAppWeb.extras} component={Extras} />
      <DashScreens.Screen
        name={EnumRoutesAppWeb.banners}
        component={BannerList}
      />
      <DashScreens.Screen name={EnumRoutesAppWeb.pushes} component={PushList} />
    </DashScreens.Group>
    <DashScreens.Group screenOptions={screenOptions}>
      <DashScreens.Screen
        name={EnumRoutesAppWeb.showUser}
        component={UserDetail}
      />
      <DashScreens.Screen
        name={EnumRoutesAppWeb.createEditCategory}
        component={BlogCategoryForm}
      />
      <DashScreens.Screen
        name={EnumRoutesAppWeb.createEditBlog}
        component={PostForm}
      />
      <DashScreens.Screen
        name={EnumRoutesAppWeb.createEditActivity}
        component={ActivityForm}
      />
      <DashScreens.Screen
        name={EnumRoutesAppWeb.createEditExtra}
        component={ExtraForm}
      />
      <DashScreens.Screen
        name={EnumRoutesAppWeb.createEditShopping}
        component={ShoppingForm}
      />
      <DashScreens.Screen
        name={EnumRoutesAppWeb.createEditDesenvolvimento}
        component={DesenvolvimentoForm}
      />
      <DashScreens.Screen
        name={EnumRoutesAppWeb.createEditBanner}
        component={BannerForm}
      />
      <DashScreens.Screen
        name={EnumRoutesAppWeb.createEditPush}
        component={PushForm}
      />
    </DashScreens.Group>
  </DashScreens.Navigator>
);

const App = () => {
  useEffect(() => {}, []);

  return (
    <SafeAreaProvider>
      <View style={{ flex: 1 }}>
        <AppHeader />
        <NavigationContainer theme={themeTab} ref={navigationRef}>
          <Drawer.Navigator
            initialRouteName="HomeDash"
            screenOptions={{ headerShown: false }}
            drawerContent={() => <Menu />}
          >
            <Drawer.Screen name="HomeDash" component={Nav} />
          </Drawer.Navigator>
        </NavigationContainer>
        <AppFooter />
      </View>
    </SafeAreaProvider>
  );
};

export default App;
